import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppBarCMS } from '../../../../basic';
import { Spinner } from '../../../../common';
import YellowBookForm from './YellowBookForm.jsx';
import {
  useGenerateYellowBookPdfMutation,
  useGetYellowBookQuery,
  useGetYellowBooksQuery,
  useSaveYellowBookMutation,
} from '../../../../../redux/services/yellow_books';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import { routes } from '../../../../../utils/helpers/ApiClient';

const YellowBooksEdit = ({ mode }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { saveSuccess, successMessage, infoMessage } = useToastMessages();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';

  useEffect(() => {
    document.title = isEdit
      ? t('Úprava žltej knižky') + ' - FRI CMS'
      : t('Pridanie žltej knižky') + ' - FRI CMS';
  }, []); // Runs on mount

  const { data: bookDetail, isLoading } = useGetYellowBookQuery(id, {
    skip: !isEdit,
  });

  const [saveYellowBook, { isSuccess: isSaveSuccess }] =
    useSaveYellowBookMutation();

  const [generateYellowBookPdf, { isSuccess: isGenerateSuccess }] =
    useGenerateYellowBookPdfMutation();

  const { refetch } = useGetYellowBooksQuery();

  useEffect(() => {
    if (isSaveSuccess) {
      saveSuccess();
      navigate(routes.cmsYellowBooks);
      refetch();
    }
  }, [isSaveSuccess]);

  useEffect(() => {
    if (isGenerateSuccess) {
      successMessage({
        message: t('PDF bolo úspešne vygenerovaný'),
      });
      navigate(routes.cmsYellowBooks);
      refetch();
    }
  }, [isGenerateSuccess]);

  const title = isCreate
    ? t('Pridanie žltej knižky')
    : t('Úprava žltej knižky');

  if (isEdit && isLoading) return <Spinner />;

  const initials = {
    title: undefined,
    title_en: undefined,
    visible: true,
    ...bookDetail,
    settings: {
      fontSizeText: 8,
      fontSizeHeader: 8,
      fontSizeTable: 8,
      marginTop: 40,
      marginRight: 26,
      marginBottom: 30,
      marginLeft: 26,
      marginHeader: 45,
      marginFooter: 20,
      ...bookDetail?.settings,
    },
  };

  return (
    <>
      <AppBarCMS
        title={title}
        backUrl={routes.cmsYellowBooks}
        backUrlTooltip={t('Žlté knižky')}
        permissionsBasic="yellow-books"
      />
      <div style={{ margin: '10px' }}>
        <YellowBookForm
          initials={initials}
          isEdit={isEdit}
          onSubmit={(values) => {
            saveYellowBook({ body: values, id });
          }}
          onGenerateClick={() => {
            infoMessage({
              message: t('Generovanie PDF, prosím čakajte'),
            });
            generateYellowBookPdf(id);
          }}
          onTemporaryGenerateClick={() =>
            window.open(`/api/yellow-books/${id}/pdf`, '_blank')
          }
        />
      </div>
    </>
  );
};

export default YellowBooksEdit;
